import { createIcon } from "@chakra-ui/react";

export const NetworkPath = createIcon({
  displayName: "NetworkPath",
  viewBox: "0 0 24 24",
  d: "M5.75 5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm3.75-1.5a3.748 3.748 0 0 1-2.625 3.577V12a5.596 5.596 0 0 1 3.375-1.125h4.5A3.373 3.373 0 0 0 18.125 7.5v-.173A3.749 3.749 0 0 1 19.25 0a3.749 3.749 0 0 1 1.125 7.327V7.5a5.623 5.623 0 0 1-5.625 5.625h-4.5A3.373 3.373 0 0 0 6.875 16.5v.173A3.749 3.749 0 0 1 5.75 24a3.749 3.749 0 0 1-1.125-7.327V7.327A3.749 3.749 0 0 1 5.75 0 3.749 3.749 0 0 1 9.5 3.75zm11.25 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm-15 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  defaultProps: {
    "aria-label": "A network tree icon with three dots connected by lines"
  }
});

export default NetworkPath;
